import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * Histórico das últimas 50 runs do agent-intake-document.
 */
export function useIntakeRuns() {
  return useSupabaseQuery(
    (sb) => sb.from('intake_runs').select('*').order('created_at', { ascending: false }).limit(50),
    []
  );
}
